import type { Project } from '../../../types/project'
import { ProjectCard } from '../../molecules/ProjectCard/ProjectCard'
import styles from './ProjectsSection.module.css'

/* ── Données statiques des projets actifs ────── */
const PROJECTS: Project[] = [
    {
    id: 'feedverse',
    name: 'Feedverse',
    image:
      'https://feedverse.app/feedverse-icon.svg',
    imageAlt: 'Aperçu du projet Feedverse',
    description:
      'Réseau social dédié aux univers fictifs — partage, discussions et communautés autour de la fiction.',
    stack: ['Node.js', 'Express.js', 'TypeScript', 'PostgreSQL', 'Clean Architecture', 'Jest'],
    githubUrl: 'https://github.com/fyambos',
    liveUrl: 'https://feedverse.app/',
  },
  {
    id: 'waitify',
    name: 'Waitify',
    image:
      'https://t3.ftcdn.net/jpg/00/92/66/20/360_F_92662026_9fiMh5jgCBIo9il3sQgMQCXdZ0W5afBa.jpg',
    imageAlt: 'Aperçu du projet Waitify',
    description:
      'Système de file d\'attente virtuelle via QR code pour les commerces. Backend API et infrastructure cloud.',
    stack: ['ASP.NET', 'Entity Framework', 'C#', 'Clean Architecture', 'PostgreSQL', 'GCP', 'DigitalOcean', 'Docker'],
    githubUrl: 'https://github.com/StevenYAMBOS/waitify-api',
    // liveUrl: 'https://waitify.fr',
  },
  {
    id: 'smash-here',
    name: 'Smash Here',
    image:
      'https://t3.ftcdn.net/jpg/00/92/66/20/360_F_92662026_9fiMh5jgCBIo9il3sQgMQCXdZ0W5afBa.jpg',
    imageAlt: 'Aperçu du projet Smash Here',
    description:
      'Plateforme e-sport communautaire transformant l\'apprentissage des jeux en roadmaps personnalisées et structurées.',
    stack: ['Kotlin', 'Spring Boot', 'Clean Architecture', 'PostgreSQL (NeonDB)', 'Cloudflare', 'Docker', 'GitHub Actions'],
    githubUrl: 'https://github.com/StevenYAMBOS/Smash-Here-API',
    // liveUrl: 'https://smashhere.fr',
  },
]

export function ProjectsSection() {
  return (
    <section id="projects" className={styles.section} aria-labelledby="projects-title">
      {/* ── En-tête ── */}
      <div className={styles.header}>
        <h2 id="projects-title" className={styles.title}>
          Projets
        </h2>
        {/* Barre décorative gradient sous le titre */}
        <div className={styles.titleBar} aria-hidden="true" />
        <p className={styles.subtitle}>
          Voici une petite liste des projets sur lesquels j'ai travaillé ou contribué. Que ce soit des projets personnels, open-source, ou professionnels, j'essaie toujours de mettre en avant mes compétences et ma passion pour le développement (surtout côté Back, vive le Back !).
        </p>
      </div>

      {/* ── Grille de cards ── */}
      <ul className={styles.grid} role="list" aria-label="Liste des projets">
        {PROJECTS.map((project) => (
          <li key={project.id} className={styles.gridItem}>
            <ProjectCard project={project} />
          </li>
        ))}
      </ul>
    </section>
  )
}